import Coverage from 'pages/benefits/coverage/Coverage';
import { CoveragePlan } from 'all-in-one-shared-api';

function Maternity() {
  return <Coverage coveragePlan={CoveragePlan.MATERNITY} />;
}

export default Maternity;
